import { OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SessionStorage } from '@app/types/session-storage.enum';
import { _ } from '@app/translation-marker';
import { FormControl } from '@angular/forms';
import { AutoRenewService } from '@app/auto-renew/auto-renew.service';
import { Flows } from '@app/auto-renew/auto-renew.type';
var RatePlanComponent = /** @class */ (function () {
    function RatePlanComponent(breakpointObserver, autoRenewService) {
        this.breakpointObserver = breakpointObserver;
        this.autoRenewService = autoRenewService;
        this.isDesktop = true;
        this.locale = sessionStorage.getItem(SessionStorage.Language);
        this.chargeTranslationKeys = {
            Annual: _('charge.upfront'),
            Semi_Annual: _('charge.upfront'),
            Month: _('charge.monthly'),
            Quarter: _('charge.quarterly'),
            Eighteen_Months: _('charge.upfront'),
            Two_Years: _('charge.upfront'),
            Three_Years: _('charge.upfront')
        };
        this.autoRenewKeys = {
            Enabled: _('auto_renew.enabled'),
            Disabled: _('auto_renew.disabled'),
        };
        this.autoRenewControl = new FormControl();
    }
    Object.defineProperty(RatePlanComponent.prototype, "ratePlan", {
        get: function () {
            return this._ratePlan;
        },
        set: function (ratePlan) {
            this._ratePlan = ratePlan;
            this.autoRenewControl.setValue(ratePlan.autoRenew, { emitEvent: false });
        },
        enumerable: true,
        configurable: true
    });
    RatePlanComponent.prototype.handleToggleClick = function () {
        var autoRenewValue = !this.autoRenewControl.value;
        this.autoRenewService.trigger(autoRenewValue, this.handleSuccess.bind(this), this.handleError.bind(this));
    };
    RatePlanComponent.prototype.handleSuccess = function (flow, value) {
        switch (flow) {
            case Flows.AUTO_RENEW_UPDATE:
                this.autoRenewControl.reset(!this.autoRenewControl.value);
                break;
            case Flows.CANCELLATION_IN_PROGRESS:
                // EMPTY
                break;
            case Flows.CANCELLATION_REQUEST:
                // EMPTY
                break;
            default:
            // EMPTY
        }
    };
    RatePlanComponent.prototype.handleError = function () {
        // EMPTY
    };
    RatePlanComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.autoRenewService.initialize(this.ratePlan, this.account.accountId);
        this.isAutoRenewDisabled = this.autoRenewService.isAutoRenewDisabled;
        this.currencyDisplay = this.ratePlan.currency === 'TRY' ? '' : 'symbol';
        this.breakpointObserver
            .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
            .subscribe(function (result) {
            _this.isDesktop = result.matches;
        });
    };
    return RatePlanComponent;
}());
export { RatePlanComponent };
